@if (subscription) {
  <app-change-itemized-billing (back)="resetWorkflowAndRedirect()"
  (selected)="onItemizedBillingChanged($event)"></app-change-itemized-billing>
}
